<script setup lang="ts">
  import { computed, ref } from 'vue'
  import { useRegisterSW } from 'virtual:pwa-register/vue'
  // periodic sync is disabled, change the value to enable it, the period is in milliseconds
  // You can remove onRegisteredSW callback and registerPeriodicSync function
  const period = 60 * 60 * 1000
  const swActivated = ref(false)
  /**
   * This function will register a periodic sync check every hour, you can modify the interval as needed.
   */
  function registerPeriodicSync(swUrl: string, r: ServiceWorkerRegistration) {
    if (period <= 0) return

    setInterval(async () => {
      if ('onLine' in navigator && !navigator.onLine) return

      const resp = await fetch(swUrl, {
        cache: 'no-store',
        headers: {
          cache: 'no-store',
          'cache-control': 'no-cache',
        },
      })

      if (resp?.status === 200) await r.update()
    }, period)
  }

  const { needRefresh, updateServiceWorker } = useRegisterSW({
    immediate: true,
    onRegisteredSW(swUrl, r) {
      if (period <= 0) return
      if (r?.active?.state === 'activated') {
        swActivated.value = true
        registerPeriodicSync(swUrl, r)
      } else if (r?.installing) {
        r.installing.addEventListener('statechange', e => {
          const sw = e.target as ServiceWorker
          swActivated.value = sw.state === 'activated'
          if (swActivated.value) registerPeriodicSync(swUrl, r)
        })
      }
    },
  })

  const title = computed(() => {
    console.log('title', needRefresh.value)

    if (needRefresh.value) return '页面有更新，请单击确认更新按钮进行更新。'
    return ''
  })

  function close() {
    needRefresh.value = false
  }
</script>

<template>
  <el-dialog
    v-model="needRefresh"
    title="温馨提示"
    width="500"
    :before-close="close"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <span>{{ title }}</span>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="needRefresh = false">取消更新</el-button>
        <el-button type="primary" @click="updateServiceWorker()">
          确认更新
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>
